import moment, { Moment } from "moment";
import { DATE_TIME_FORMATS } from "../data/constants";

/**
 * This function will return all the dates between two dates in an array in a format which has been passed
* DON'T USE THIS FUNTION IN FUTURE. USE enumerateDaysBetweenDatesNew INSTEAD
* @param startDate
 * @param endDate
 * @param dateFormat
 */
export const enumerateDaysBetweenDates = function (
  startDate: Moment,
  endDate: Moment,
  dateFormat: string
) {
  const dates = [];
  let currDate = moment(startDate).startOf("day");
  let lastDate = moment(endDate).startOf("day");
  dates.push(currDate.format(dateFormat));
  while (currDate.add(1, "days").diff(lastDate) < 0) {
    dates.push(currDate.clone().format(dateFormat));
  }
  dates.push(endDate.format(dateFormat));
  return dates;
};

/**
 * This function will return all the dates between two dates in an array in a format which has been passed
 * @param startDate
 * @param endDate
 * @param dateFormat
 */
export const enumerateDaysBetweenDatesNew = function (
  startDate: Moment,
  endDate: Moment,
  dateFormat: string
) {
  const dates = [];
  let currDate = moment(startDate).startOf("day");
  let lastDate = moment(endDate).startOf("day");
  dates.push(currDate.format(dateFormat));
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    dates.push(currDate.clone().format(dateFormat));
  }
  return dates;
};

/**
 * This function will fromat the given moment value and return it as string
 * @param value
 * @param format
 */
export const convertMomentToString = (value: Moment | null, format: string) => {
  return value ? moment(value).format(format) : "";
};

/**
 * 
 * @param months 2024-06, 2024-07 etc
 * @returns all dates in the months 1-06-2024, 2-06-2024,... etc
 */
export function convertMonthToDates(months: string[], convertFormat = DATE_TIME_FORMATS.yearMonthDay) {
  let datesList: string[] = []
  months.forEach((month) => {
    let daysInMonth = moment(month).daysInMonth();
    let iterator = 1;
    while(iterator <= daysInMonth) {
      const current = moment(month).date(iterator);
      datesList.push(current.format(convertFormat));
      iterator++;
    }
  })
  return datesList;
}

export function dateToDDMMYY(date: string) {
  const newDate = new Date(date);
  return (newDate.getDay() + 1) + "/" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
}